// Reading a stored file's bytes in the browser (an invoice PDF to attach or to read).
//
// /api/files answers with a redirect to a short-lived signed URL on Supabase storage, which
// sends `Access-Control-Allow-Origin: *`. A fetch made with credentials: "include" follows
// that redirect and is then refused by the browser - a wildcard origin is not allowed with
// credentials - and fails with a bare "Failed to fetch". The default, "same-origin", still
// sends the portal's session cookie to /api/files, which is the only place it is needed.
export async function fetchStoredFile(url, fetchImpl = globalThis.fetch) {
  const response = await fetchImpl(url, { credentials: "same-origin" });
  if (!response.ok) throw new Error(`The file could not be opened (${response.status}).`);
  return new Uint8Array(await response.arrayBuffer());
}
